import React from "react";
import LoveLetter from "@/components/LoveLetter";

export default function LetterPage() {
  return <LoveLetter />;
}
